




















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator"; // 2022-12-08 sh #8122(BQR982) add Watch.
import { dateToFormat } from "@/service/util";
import { auth } from "@/service/auth";
import { Action, Getter } from "vuex-class";
import { StompClient } from "@/service/StompClient";
import requestService from "@/service/requestService";
import { PromiseService } from "@/service/PromiseService";
/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import SknMenuDialog from "@/components/sknMenuDialog.vue";
import { InspectDetail } from "@/model/InspectDetail";
import { InspectionDetailService } from "@/service/InspectionDetailService";
import { MESSAGE } from "@/model/Message";
/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

@Component({
  components: {
    ConfirmDialog
    , SknMenuDialog
  }
})
export default class Header extends Vue {
  @Prop({ default: false })
  isReservation: boolean;
  @Prop() showmenu: boolean;
  @Prop() searchbox: boolean;

  
  @Action("setFontSizeLevel", { namespace: "GlobalValue" })
  setFontSizeLevel: any;

  @Getter("fontSizeLevel", { namespace: "GlobalValue" })
  fontSizeLevelVal: number;

  @Action("clearTimerRefeshToken", { namespace: "Authentication" })
  clearTimerRefeshToken: any;

  @Action("clearState", { namespace: "Authentication" })
  clearStateAuth: any;

  @Action("clearState", { namespace: "ReservationDetail" })
  clearStateReservation: any;

  @Action("clearState", { namespace: "InspectionDetail" })
  clearStateInspectDetail: any;

  @Action("clearState", { namespace: "SubHeader" })
  clearStateTime: any;

  @Action("clearState", { namespace: "InspectSeibi" })
  clearStateStatusResult: any;

  @Action("clearState", { namespace: "CarSelection" })
  clearStateCarSelection: any;

  @Action("clearState", { namespace: "Inspect" })
  clearStateInspect: any;

  @Action("clearState", { namespace: "Shohiyou" })
  clearStateShohiyou: any;

  @Action("clearState", { namespace: "Coupon" })
  clearStateCoupon: any;

  @Action("clearState", { namespace: "Environment" })
  clearStateEnvironment: any;

  @Action("clearState", { namespace: "WorkOrder" })
  clearStateWorkOrder: any;

  @Action("clearState", { namespace: "Payment" })
  clearPayment: any;

  @Action("clearState", { namespace: "UserDataState" })
  clearUserData: any;

  @Getter("socket", { namespace: "Socket" })
  socket: StompClient;
  @Action("disconnect", { namespace: "Socket" })
  disconnectSocket: any;

  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  /** 2021-05-25 sh #6973 feature function setting [START] */
  @Action("clearState", { namespace: "QuickMitsumoriQrInfo" })
  clearQuickMitsumoriQrInfo: any;

  @Action("clearState", { namespace: "FunctionSetting" })
  clearFunctionSetting: any;

  /** 2021-05-25 sh #6973 feature function setting [END] */

  /** 2021-07-30 sh #6989 implements quick mitsumori. [START] */
  @Getter("currentState", { namespace: "QuickMitsumoriQrInfo" })
  currentStateQuickMitsumoriQrInfo: any;
  /** 2021-07-30 sh #6989 implements quick mitsumori. [END] */

  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
  @Getter("isValid", { namespace: "FunctionSetting" })
  isValidFunctionSetting: any;
  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Action("clearState", { namespace: "Buhin" })
  clearBuhin: any;

  @Action("setSeibiMenuCd", { namespace: "InspectionDetail" })
  setSeibiMenuCd: any;

  @Action("setShakenShuruiNm", { namespace: "InspectionDetail" })
  setShakenShuruiNm: any;
  @Action("setShakenShuruiSeibiMenuUpdatedAt", { namespace: "InspectionDetail" })
  setShakenShuruiSeibiMenuUpdatedAt: any;

  @Getter("seibiMenuCd", { namespace: "InspectionDetail" })
  selectingSeibiMenuCd: string;

  @Getter("getShakenShuruiNm", { namespace: "InspectionDetail" })
  shakenShuruiNm: any;

  @Getter("getShakenShuruiSeibiMenuUpdatedAt", { namespace: "InspectionDetail" })
  shakenShuruiSeibiMenuUpdatedAt: any;

  /** 2023-01-27 sh #8180(BQR1080) add change course. [START] */
  @Getter("isCanChangeCourse", { namespace: "FunctionSetting"} )
  isCanChangeCourse: any;
  /** 2023-01-27 sh #8180(BQR1080) add change course. [END] */

  reqService: requestService;
  seibiMenuCd: string = "";

  $refs!: {
    errorDialog: ConfirmDialog;
    sknMenuDialog: SknMenuDialog;
    dialog: ConfirmDialog;
  };
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  _auth: auth;
  inputFilter: string = "";
  date: string = "";
  time: string = "";
  filterField: any = null;
  filterFields: any = [
    { key: null, label: "" },
    { key: "srPlateNo", label: "ナンバー" },
    { key: "kkUketsukeNm", label: "顧客名" },
    { key: "shadaiNo", label: "車台番号" }
  ];
  showStatus: boolean = false;
  serverDateTime: Date = new Date();
  isUserMode: boolean = false;
  fontSizeLevel = 2;

  get isConnected() {
    /** 2021-08-25 sh #7361 add check for quick mitsumori. [START] */
    if (!this.socket || typeof this.socket.isConnected !== "function") {
      return false;
    }
    /** 2021-08-25 sh #7361 add check for quick mitsumori. [END] */
    return this.socket.isConnected();
  }

  created() {
    this.fontSizeLevel = this.fontSizeLevelVal;
    this._auth = new auth();
    const reqService: requestService = new requestService();
    if (this.$route.meta == "user") {
      this.isUserMode = true;
    }
    reqService.asyncGetServerTime().then((serverTime: number) => {
      this.serverDateTime = new Date(serverTime);
      this.startTimer();
      this.setDateTime();
    });

    if (process.env.NODE_ENV == "staging" || process.env.NODE_ENV == "development") {
      this.showStatus = true;
    }

    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.reqService = new requestService();
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

    /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
    /** F5とか押されるとなくなってしまうので、再取得をしておく */
    if (!this.isValidFunctionSetting) {
      const promiseService = new PromiseService();
      const promise = promiseService.getFunctionSettingPM();
      Promise.all([promise]).then(() => {});
    }
    /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */

    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    if (this.isShowChangeShakenShurui) {
      const inspectionDetailService = new InspectionDetailService();
      inspectionDetailService.getInspectionDetail(this.uketsukeExtendsId);
    }
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
  }

  getDate() {
    return dateToFormat(this.serverDateTime, "MM/DD");
  }

  getTime() {
    return dateToFormat(this.serverDateTime, "HH:mm");
  }

  setDateTime() {
    this.date = this.getDate();
    this.time = this.getTime();
  }

  updateTime() {
    const min = this.serverDateTime.getMinutes();
    this.serverDateTime.setMinutes(min + 1);
    this.serverDateTime.setSeconds(0);
    this.setDateTime();
  }

  startTimer() {
    const ms = (60 - this.serverDateTime.getSeconds()) * 1000;
    setTimeout(() => {
      this.updateTime();
      setInterval(() => {
        this.updateTime();
      }, 60000);
    }, ms);
  }

  onMenuCommand(command: string) {
    if (command == "logout") {
      this._auth.logout(() => {
        this.clearTimerRefeshToken();
        let loginName = this.$router.currentRoute.meta + "login";
        this.$router.push({ name: loginName });
        this.clearStateAuth();
        this.clearStateReservation();
        this.clearStateInspectDetail();
        this.clearStateTime();
        this.clearStateStatusResult();
        this.clearStateCarSelection();
        this.clearStateInspect();
        this.clearStateShohiyou();
        this.clearStateCoupon();
        this.clearStateEnvironment();
        this.disconnectSocket();
        this.clearStateWorkOrder();
        this.clearPayment();
        this.clearUserData();
        /** 2021-05-25 sh #6973 feature function setting [START] */
        this.clearQuickMitsumoriQrInfo();
        this.clearFunctionSetting();
        /** 2021-05-25 sh #6973 feature function setting [END] */
      });
    }
  }

  onSearch() {
    this.$emit("onsearch", { value: this.inputFilter, key: this.filterField });
  }

  /** 2021-07-30 sh #6989 implements quick mitsumori. [START] */
  get isShowButtonQuickMitsumori() {
    let rslt: boolean = false;

    if (this.$route.name == 'recmaintenance'
    && this.currentStateQuickMitsumoriQrInfo
    && this.currentStateQuickMitsumoriQrInfo.isHasQuickMitsumori == 1) {
      rslt = true;
    }

    return rslt;
  }
  onShowQuickMitsumori() {
    console.log("Header.onShowQuickMitsumori", this.isShowButtonQuickMitsumori);
    let url = this.currentStateQuickMitsumoriQrInfo.qrUrl;
    let title = "ｸｲｯｸ見積もり";
    let w = 1024;
    let h = 1024;

    let dualScreenLeft = window.screenLeft; // !== undefined ? window.screenLeft : screen.left;
	  let dualScreenTop = window.screenTop; // !== undefined ? window.screenTop : screen.top;

	  let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	  let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	  let left = ((width / 2) - (w / 2)) + dualScreenLeft;
	  let top = ((height / 2) - (h / 2)) + dualScreenTop;
	  let newWindow: any = window.open(url, title, 'menubar=no, status=no, toolbar=no, scrollbars=1, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	  // Puts focus on the newWindow
	  if (window.focus) {
		  newWindow.focus();
	  }
  }
  /** 2021-07-30 sh #6989 implements quick mitsumori. [END] */

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  get isShowChangeShakenShurui() {

    /** 2023-01-27 sh #8180(BQR1080) add change course. [START] */
    if (!this.isCanChangeCourse) {
      return false;
    }
    /** 2023-01-27 sh #8180(BQR1080) add change course. [END] */

    if (!this.selectingSeibiMenuCd || this.selectingSeibiMenuCd == '') {
      return false;
    }

    if (this.$route.name == 'customer'
    || this.$route.name == 'inspectiondetail'
    || this.$route.name == 'factorylogin'
    || this.$route.name == 'userlogin'
    || this.$route.name == 'reservation'
    ) {
      return false;
    }

    if (this.isUserMode && (
      this.$route.name == "usercustomer"
      || this.$route.name == "statusresult"
      || this.$route.name == "workdetail"
      || this.$route.name == "inspectioncost"
      || this.$route.name == "userlegal56"
      || this.$route.name == "userrecommend"
      || this.$route.name == "discountcoupon"
      || this.$route.name == "option"
      || this.$route.name == "paymentdetail"
    )) {
      return true;
    }
    return !this.isUserMode;
  }

  showSknMenuDialog() {
    this.$refs.sknMenuDialog.onOpen();
  }

  onConfirm(seibiMenuCd: string) {
    this.seibiMenuCd = seibiMenuCd;
    this.$refs.dialog.onOpen();
  }

  updateShakenShurui() {
    let inspectionDetail: InspectDetail = {
      kensain: [],
      seibishi: [],
      hojoSeibishi: []
      , uketsukeExtendId: this.uketsukeExtendsId
      , shakenShuruiSeibiMenuCd: this.seibiMenuCd
      , screen: this.$route.meta
      , shakenShuruiSeibiMenuUpdatedAt: this.shakenShuruiSeibiMenuUpdatedAt
    };
    this.$refs.sknMenuDialog.setLoading(true);
    this.reqService.updateShakenShurui(inspectionDetail).then(
      (res: any) => {
        this.clearBuhin();
        this.setSeibiMenuCd(this.seibiMenuCd);
        if (res.body) {
          this.setShakenShuruiNm(res.body.shakenShuruiNm);
          this.setShakenShuruiSeibiMenuUpdatedAt(res.body.shakenShuruiSeibiMenuUpdatedAt);
        } else {
          if (res.status && res.status == 204) {
            this.$notify.error({
              title: "Error",
              message: MESSAGE.UpdatedShakenIntegrityError
            });
          }
        }
        this.$refs.sknMenuDialog.selShakenShurui(this.seibiMenuCd);
        this.$refs.sknMenuDialog.setLoading(false);
        this.$refs.sknMenuDialog.onClose();
      }
    );
  }

  get selectingShakenShuruiNm() {
    return this.shakenShuruiNm;
  }

  @Watch("selectingSeibiMenuCd")
  reInitShakenShurui() {
    const inspectionDetailService = new InspectionDetailService();
    inspectionDetailService.getInspectionDetail(this.uketsukeExtendsId);
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
}
